import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { ApiMethod } from "../decorators/api-method.decorator";
import { Observable } from "rxjs";

@Injectable({
	providedIn: 'root'
})
export class HelpService {
	private readonly baseUrl = `${environment.baseUrl}/help`;

	constructor(
		private http: HttpClient
	) { }

	@ApiMethod()
	public saveHelpRequest(token, formData): Observable<any> {
		return this.http.post<any>(`${this.baseUrl}/${token}`, formData);
	}
}